document.addEventListener('DOMContentLoaded', () => {
    // Create GSAP timeline
    const tlhpshaft = gsap.timeline({
        scrollTrigger: {
            trigger: ".kg-out-wrap-intro", 
            start: "top 80%", 
            end: "bottom bottom", 
            toggleActions: "play none none none", 
        }
    });

    // Animate the image with a 1-second fade-in duration
    tlhpshaft.fromTo(".kg-shaft-img-cont img", {
        x: -400,
        opacity: 0
    }, {
        x: 0,
        opacity: 1,
        duration: .5,
        ease: 'power3.out'
    });

    // Animate the rotate links, starting 0.5 seconds before the image animation ends
    tlhpshaft.fromTo(".rotate", {
        x: -500,
        opacity: 0
    }, {
        x: 0,
        opacity: 1,
        duration: 0.4,
        stagger: 0.3,
        ease: 'power3.out'
    }, "-=1"); 
});
